// Authentication is enforced through two complementary mechanisms:
//  1. Transition hooks
//      https://jsantacl.medium.com/angular-ui-router-navigation-guards-4a34752e89a8
//  2. HttpInterceptor
//      https://javascript.plainenglish.io/angular-handle-http-errors-using-interceptors-5cc483103740
// See also: README.md#http-interceptor-architecture-hybrid

import { HttpErrorResponse, HttpRequest, HttpHandler, HttpInterceptor, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    // Purpose:
    // - Provide one global observation point for HttpClient errors.
    // - Keep behavior minimal (log + rethrow) so feature interceptors own
    //   route-specific auth decisions and redirect policy.
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Pass-through the request and attach a global error tap.
        return next.handle(req)
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(err: HttpErrorResponse): Observable<any> {
        // Current strategy: emit diagnostic signal, then propagate unchanged.
        // Do not swallow/transform here; callers and specialized interceptors rely
        // on original error semantics.
        console.log(err);
        return throwError(() => err);
    }
}
